import { TaskType } from "src/types";
import { SuggestionContext } from "./types";
import { isValueTaskType } from "src/utils/methods";

const NO_CONTEXT = null;

const WORKSPACE_PREFIX = /^\/workspace\/[^/]+\/?/;

// Only the segments that identify the context are read; anything after them
// (e.g. an opened task pane's :taskId) is ignored on purpose so opening/closing
// such panes doesn't change context and doesn't retrigger a fetch.
export function getAISuggestsContext(
  pathname: string,
  search: string,
): SuggestionContext | null {
  const prefixMatch = pathname.match(WORKSPACE_PREFIX);

  if (!prefixMatch) return NO_CONTEXT;

  const segments = pathname
    .slice(prefixMatch[0].length)
    .split("/")
    .filter(Boolean);

  const [section] = segments;

  switch (section) {
    case "homepage":
      return "get-started";

    case "get-started":
    case "creator-database":
    case "coupon-groups":
    case "activity":
      return section;

    case "summary":
      return "data-hub";

    case "projects": {
      const searchParams = new URLSearchParams(search);

      const isCreatorSearchTab = searchParams.get("tab") === "creatorSearch";
      const taskTypeTab = searchParams.get("taskType");
      const isTaskTypeTab = isValueTaskType(taskTypeTab);

      if (isCreatorSearchTab) return "creator-search";
      if (isTaskTypeTab) return `project-${taskTypeTab as TaskType}s`;

      return "projects";
    }

    case "dict":
      return "dictionary";

    case "my-actions":
      return "my-tasks";

    default:
      return NO_CONTEXT;
  }
}
